import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["interactionType"];
import { useEffect } from 'react';
import { getLastSentThirdPartySubjectFromParent, setLastSentThirdPartySubjectInParent } from 'calling-integration-sdk-support/utils/windowUtils';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { parseQueryFromLocation } from '../utils/parseQueryFromLocation';
import { handleDialThirdParty } from '../utils/handleDialThirdParty';
import { openCallingWindow } from '../utils/callingWindowUtils';
import { useOpenCloseRemote } from './useOpenCloseRemote';
import { useOpenWidgetDataContext } from 'calling-integration-sdk-support/viewport/contexts/OpenWidgetDataContext';
import { useThirdPartyGates } from './useThirdPartyGates';
import { sendCrossTabMessage } from 'worker-connection-library/calling-cross-tab-utils/sendCrossTabMessage';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { OPEN_WIDGET } from 'calling-integration-cross-tab/types/BroadcastEvents';
export function useTaskQueue({
  ownerId,
  usesCallingWindow
}) {
  const {
    openRemote,
    setHasThirdPartyOpened
  } = useOpenCloseRemote();
  const [context] = useThirdPartyWidgetDetailsContext();
  const {
    thirdPartyIsPopupOpen,
    thirdPartyCallStatus
  } = context;
  const {
    updateOpenWidgetDataForCallingWindow,
    updateOpenWidgetDataForRemote
  } = useOpenWidgetDataContext();
  const {
    isRemoteEnabled
  } = useThirdPartyGates();
  useEffect(() => {
    if (ownerId === null) return;
    const {
      taskId
    } = parseQueryFromLocation(window.parent.location);
    if (!taskId) return;
    const lastSentThirdPartySubject = getLastSentThirdPartySubjectFromParent();
    if (!lastSentThirdPartySubject) return;
    const {
        interactionType
      } = lastSentThirdPartySubject,
      rest = _objectWithoutPropertiesLoose(lastSentThirdPartySubject, _excluded);
    if (interactionType === 'call') {
      openRemote();
      setHasThirdPartyOpened(true);
      if (!usesCallingWindow) {
        handleDialThirdParty({
          openWidgetEvent: {
            toSubject: lastSentThirdPartySubject
          },
          ownerId,
          dialNumberProcessors: [updateOpenWidgetDataForRemote]
        });
      } else {
        if (isRemoteEnabled) {
          handleDialThirdParty({
            openWidgetEvent: {
              toSubject: lastSentThirdPartySubject
            },
            ownerId,
            dialNumberProcessors: [updateOpenWidgetDataForRemote]
          });
        }
        if (!thirdPartyIsPopupOpen) {
          openCallingWindow();
          handleDialThirdParty({
            openWidgetEvent: {
              toSubject: lastSentThirdPartySubject
            },
            ownerId,
            dialNumberProcessors: [updateOpenWidgetDataForCallingWindow]
          });
        } else {
          handleDialThirdParty({
            openWidgetEvent: {
              toSubject: lastSentThirdPartySubject
            },
            ownerId,
            dialNumberProcessors: [dialNumberDetails => sendCrossTabMessage(createBroadcastMessage({
              type: OPEN_WIDGET,
              payload: {
                dialNumberDetails
              }
            }))]
          });
        }
      }
      setLastSentThirdPartySubjectInParent(Object.assign({}, rest));
    }
  }, [openRemote, ownerId, setHasThirdPartyOpened, thirdPartyCallStatus, thirdPartyIsPopupOpen, usesCallingWindow, updateOpenWidgetDataForCallingWindow, updateOpenWidgetDataForRemote, isRemoteEnabled]);
}